import { filter } from 'lodash';
import api from '.';

import { buildQueryWithParams, makeListTags } from '../../Utils/api';

const tagType = 'meterValues';

const meterValuesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    requestAllMeterValues: builder.query({
      query: ({ sessionId, filter }) => ({
        url: `/sessions/${sessionId}/charger-meters`,
        // Call /charger meeters with filter ( deleted route )
        params: {filter}
      }),
      transformResponse: (res) => ({
        list: res
      }),
      providesTags: makeListTags(tagType)
    })
  })
});
export default meterValuesApi;
export const { useRequestAllMeterValuesQuery } = meterValuesApi;
